import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import CountryForm from "./CountryForm";
import { countryValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router-dom";

const EditCountry = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(countryValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
        group: data?.data?.group?.map((item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })),
      };
    },
  });
  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <CountryForm
        errors={errors}
        register={register}
        setValue={setValue}
        clearErrors={clearErrors}
        getValues={getValues}
      />
    </FormLayout>
  );
};

export default EditCountry;
